'use strict';
import {buildListActions} from '../../_libs/redux-observable-list/src/actions';

export const PROJECT_LIST_NAME = 'projects';

/** @type {ReduxObservableListActions} **/
export const projectListActions = buildListActions({prefix: `@@${PROJECT_LIST_NAME}`});



// WEBPACK FOOTER //
// ./src/js/projects/actions/projectListActions.js